import { useState } from 'react';
import { Button, Card, Row, Col } from 'react-bootstrap';
import Skeleton from './skeleton/GenericSkeleton';
import FilterModal from '../../../common/filter-modal/FilterModal';
import { CoverageHistory } from './coverageHistory';
import DownloadDocumentModal from '././DownloadDocumentModal/DownloadDocumentModal';
//import CustomClientError from '../../../../errorhandling/ClientError';
import useDate from '../../../../utils/useDate';
import MasterPermissions from '../../../../api/MasterPermissions';
import httpheader from 'src/Admin/shared/httpheader';

export const PlanDetails = (PlanInfo) => {
  const [isOpenCoveragePopup, setIsOpenCoveragePopup] = useState(false);
  const [isOpenDownloadDocumentPopup, setisOpenDownloadDocumentPopup] =
    useState(false);
  const showCancel = false;
  const titleLabel = 'Coverage History';
  const showApply = true;
  const showApplyLabel = 'CLOSE';
  const activeMemType = PlanInfo?.activeMemType;
  const activeCoverageType = PlanInfo?.activeCoverageType;
  const coverageData = PlanInfo?.coverageData;
  const coverageDetails = PlanInfo?.planDetails;
  const memberCoverageDetails = PlanInfo?.planDetails?.MemberCoverage;
  const data = memberCoverageDetails?.find(
    (plans) => plans?.Product === activeCoverageType,
  );
  const dataFetching = PlanInfo?.dataFetching;
  const lastIndex = coverageData?.length;
  const membersCovered = PlanInfo?.membersCovered;

  const { formatDate } = useDate();

  const applyFilterHandler = () => {
    setIsOpenCoveragePopup(false);
  };
  console.log('Plan info is', PlanInfo);
  return (
    <>
      {dataFetching ? (
        <Skeleton />
      ) : (
        <Card className="plan-info-card">
          {data?.BenefitPlan && (
            <Row>
              <Col xs={6} className="text-right p-0">
                <span className="plan-details-lable">Benefit Plan</span>
              </Col>
              <Col xs={6}>
                <span className="plan-details-data">{data?.BenefitPlan}</span>
              </Col>
            </Row>
          )}
          <Row>
            <Col xs={6} className="text-right p-0">
              <span className="plan-details-lable">Coverage Status</span>
            </Col>
            <Col xs={6}>
              <span className="plan-details-data">
                {coverageDetails?.Status}
              </span>
            </Col>
          </Row>
          <Row>
            <Col xs={6} className="text-right p-0">
              <span className="plan-details-lable">Coverage Period</span>
            </Col>
            <Col xs={6}>
              <span className="plan-details-data">
                {formatDate(coverageDetails?.EffectiveDate)} -{' '}
                {formatDate(coverageDetails?.TerminationDate) || 'Current'}
              </span>
            </Col>
          </Row>
          <Row>
            <Col xs={6} className="text-right p-0">
              <span className="plan-details-lable">
                Coverage Effective From
              </span>
            </Col>
            <Col xs={6}>
              <span className="plan-details-data">
                {formatDate(data?.FirstEffectiveDate)}
              </span>
            </Col>
          </Row>
          <Row>
            <Col xs={6} className="text-right p-0">
              <span className="plan-details-lable">Other Insurance</span>
            </Col>
            <Col xs={6}>
              <span className="plan-details-data">
                {data?.OtherInsurance || 'NA'}
              </span>
            </Col>
          </Row>
          {activeMemType === 'Employee' && (
            <Row>
              <Col xs={6} className="text-right p-0">
                <span className="plan-details-lable">Coverage Level</span>
              </Col>
              <Col xs={6}>
                <span className="plan-details-data">{data?.CoverageLevel}</span>
              </Col>
            </Row>
          )}
          {activeMemType === 'Employee' && (
            <Row>
              <Col xs={6} className="text-right p-0">
                <span className="plan-details-lable">Members Covered</span>
              </Col>
              <Col xs={6}>
                {data?.CoveredMembers !== null
                  ? data?.CoveredMembers.map((member, index) => {
                      return (
                        <div
                          className="plan-details-data"
                          key={index}
                        >{`${member.FirstName} ${member.LastName} (${member.Relationship})`}</div>
                      );
                    })
                  : null}
              </Col>
            </Row>
          )}

          <Col className="text-center p-0">
            <p>
              <label
                className="view-coverage-summary"
                onClick={() => {
                  setIsOpenCoveragePopup(true);
                }}
              >
                View Coverage History
              </label>
            </p>
          </Col>

          {PlanInfo?.MasterId &&
            MasterPermissions.CheckPermission('Download Plan Document') && (
              <Row>
                <Col className="download-plan-document">
                  <Button
                    bsPrefix="download-plan-document-button"
                    onClick={() => {
                      setisOpenDownloadDocumentPopup(true);
                    }}
                  >
                    <span className="download-plan-document-text">
                      {httpheader.getCNAME().includes('keenan') ||
                      httpheader.getCNAME().includes('tpabenefits')
                        ? 'Download Benefit Documents'
                        : 'Download Plan Documents'}
                    </span>
                  </Button>
                </Col>
              </Row>
            )}

          <FilterModal
            isVisible={isOpenCoveragePopup}
            onHide={() => {
              setIsOpenCoveragePopup(false);
            }}
            applyFilterHandler={applyFilterHandler}
            showCancel={showCancel}
            titleLabel={titleLabel}
            showApply={showApply}
            showApplyLabel={showApplyLabel}
          >
            <CoverageHistory
              coverageData={coverageData}
              membersCovered={membersCovered}
              {...PlanInfo}
            />
          </FilterModal>

          {PlanInfo?.MasterId && (
            <DownloadDocumentModal
              isVisible={isOpenDownloadDocumentPopup}
              onHide={() => {
                setisOpenDownloadDocumentPopup(false);
              }}
              showApply={showApply}
              showApplyLabel={showApplyLabel}
              activeCoverageType={activeCoverageType}
              MasterID={PlanInfo?.MasterId}
            />
          )}
        </Card>
      )}
    </>
  );
};
